import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "../api/index.js";
import { getBootstrapClaims } from "../api/axios.config";

const initialState = {
  responseError: false,
  userClaims: null,
};

export const getUserClaims = createAsyncThunk(
  "auth/getUserClaims",
  async () => {
    try {
      const cached = getBootstrapClaims();
      if (cached) return cached;

      const response = await api.getUserClaims();
      return response.data;
    } catch (error) {
      console.error("Failed to fetch user claims:", error);
      throw error;
    }
  },
);

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthError: (state) => {
      state.responseError = true;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getUserClaims.fulfilled, (state, action) => {
      state.userClaims = action.payload;
    });
  },
});

export const { setAuthError } = authSlice.actions;

export const authReducer = authSlice.reducer;
